export enum CommonType {
    AutoUser = -1
}